import React, {useState} from 'react';
import BillingEditionForm from '../../../BillingEditionForm';



const titleStyles = {
  fontSize: 22,
  fontWeight: 'bold',
  color: '#013957',
}

const editionHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'center',
  marginBottom: 29,
}

const BillingEdition = ({handleCancel}) => {
  
  return (
    <div>
      <div style={editionHeader}>
        <p style={titleStyles}>Edita tus datos de facturación</p>
      </div>
      <BillingEditionForm handleCancel={handleCancel}/>
      
      
    </div>
  )
}

export default BillingEdition
